module.exports = __webpack_public_path__ + "static/media/kizuna-bg.304eb0d7.mp4";